const formatPhoneNumber = (value) => {
  const phoneNumber = value.replace(/\D/g, "").slice(0, 10);

  if (phoneNumber.length < 4) {
    return phoneNumber.length ? `(${phoneNumber}` : "";
  }

  if (phoneNumber.length < 7) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
  }

  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
    3,
    6
  )}-${phoneNumber.slice(6)}`;
};

export default formatPhoneNumber;